export default __webpack_public_path__ + "static/media/0084.e8564b78.jpg";